module.exports = __webpack_public_path__ + "static/media/empty-live-jobs.24394623.png";